import { Typography } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";

export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  // border-right: 4px solid ${theme.palette.primary.dark};
  padding: 10px !important;
  // margin-top: 20px;
  position: relative;
  & p {
    text-align: center;
    padding-top: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;

export const StyledContainer = styled(Container)`
  @media (max-width: 900px) {
    padding: 0 !important;
  }
`;

// export const StyledCard = styled(Card)`
//   background-color: ${theme.palette.primary.light} !important;
//   width: 100%;
//   margin-bottom: 10px;
//   position: relative;
// `;
export const StyledCard = styled(Card)`
  background-color: transparent !important;
  width: 100%;
  margin-bottom: 10px;
  position: relative;
  border-radius: 0 !important;
  box-shadow: none !important;
  border-bottom: 2px solid #0000002b;
  // :first-child {
  //   border-top: 2px solid #0000002b;
  //   padding-top: 10px;
  // }
`;

export const StyledStatusFactor = styled.div`
  display: flex;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const StyledTypography = styled(Typography)`
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  margin-left: 46px !important;
  line-height: 27px !important;
  & > span {
    color: gray;
  }
  @media (max-width: 500px) {
    margin-bottom: 0px !important;
    margin-left: 0px !important;
  }
`;

export const StyledNewMessage = styled.div`
  padding: 4px;
  background: ${theme.palette.primary.dark};
  display: inline-block;
  position: absolute;
  top: 5px;
  left: 5px;
  color: white;
  border-radius: 4px;
  font-size: 9px;
`;

export const StyledCardActions = styled(CardActions)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px !important;
  padding-top: 0 !important;
  padding-left: 0 !important;
  & > p {
    margin: 0;
  }
`;

export const StyledStatus = styled.div`
  display: flex;
  align-items: center;
  & > span {
    margin-right: 7px;
    color: #3f444c;
  }
`;

export const StyledIcondiv = styled.div`
  width: 32px;
  height: 32px;
  // background: red;
  border-radius: 100%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  & > svg {
    font-size: 35px;
  }
`;

export const ImageContainer = styled.div`
  display: inline-flex;
  margin-top: 10px;

  & > div {
    display: inline-block;
    position: relative;
  }
  & > div > img {
    width: 60px !important;
    height: 60px !important;
    border-radius: 10px;
    border: 1px solid #808080ab;
    margin: 5px;
    margin-right: 0px;
    margin-left: 10px;
    padding: 5px;
  }
  & > div > span {
    display: inline-block;
    width: 20px !important;
    height: 20px !important;
    border-radius: 100%;
    border: 1px solid #808080ab;
    position: absolute;
    z-index: 2;
    top: 0px;
    left: 4px;
  }
`;
